import React from "react";
import { ModuleConfig } from "../../types/ModuleConfig";

const WorkersList = React.lazy(() => import("./WorkersList"));
const WorkerProfile = React.lazy(() => import("./WorkerProfile"));
const WorkerForm = React.lazy(() => import("./WorkerForm"));
const TimeEntriesList = React.lazy(() => import("./TimeEntriesList"));
const TimeEntryForm = React.lazy(() => import("./TimeEntryForm"));

/**
 * Workers Module Config
 *
 * SINGLE SOURCE OF TRUTH:
 * Permissions are defined ONCE in the backend (workers/permissions.ts)
 * and fetched via the modulePermissions GraphQL query.
 *
 * Routes and nav items use `permissionLevel` (e.g. "view", "edit", "create")
 * which gets resolved to actual permission strings at runtime from the backend.
 */
const workersModuleConfig: ModuleConfig = {
    id: "workers",
    name: "Workers",
    description: "Manage worker profiles, certifications, and time entries for legal staffing",
    version: "1.0.0",
    enabled: true,
    category: "staffing",
    order: 2,
    icon: "👩‍💼",
    color: "#1E3A5F",

    routes: [
        {
            path: "/workers",
            component: WorkersList,
            permissions: [],
            permissionLevel: "view",
        },
        {
            path: "/workers/new",
            component: WorkerForm,
            permissions: [],
            permissionLevel: "create",
        },
        {
            path: "/workers/:id/edit",
            component: WorkerForm,
            permissions: [],
            permissionLevel: "edit",
        },
        {
            path: "/workers/:id/time-entries",
            component: TimeEntriesList,
            permissions: [],
            permissionLevel: "view",
        },
        {
            path: "/workers/:id/time-entries/new",
            component: TimeEntryForm,
            permissions: [],
            permissionLevel: "create",
        },
        {
            path: "/workers/:id",
            component: WorkerProfile,
            permissions: [],
            permissionLevel: "view",
        },
    ],

    navigation: [
        {
            label: "All Workers",
            path: "/workers",
            icon: "👩‍💼",
            permissions: [],
            permissionLevel: "view",
        },
        {
            label: "Add Worker",
            path: "/workers/new",
            icon: "➕",
            permissions: [],
            permissionLevel: "create",
        },
    ],

    permissions: {
        view: [],
        create: [],
        edit: [],
        delete: [],
    },

    quickActions: [
        {
            label: "View Workers",
            path: "/workers",
            icon: "👩‍💼",
            description: "Browse worker profiles and certifications",
        },
        {
            label: "Add Worker",
            path: "/workers/new",
            icon: "➕",
            description: "Create a new worker profile",
        },
    ],
};

export default workersModuleConfig;
